import React from 'react';
import { useIsDesktop } from '@/hooks/useMediaQuery';
import { ReferralsPageDesktop } from './ReferralsPage.Desktop';
import { ReferralsPageMobile } from './ReferralsPage.Mobile';

/**
 * Main Referrals Page component that switches between desktop and mobile layouts.
 * Uses screen width detection to determine which version to render.
 */
export const ReferralsPage: React.FC = () => {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <ReferralsPageDesktop />;
  }

  return <ReferralsPageMobile />;
};
